/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

export type HeadingSize = 'large' | 'medium'

/* Schemas */
export const HeadingSizeSchema = z.enum(['large', 'medium'])

/* Schemas validation */
type TestHeadingSize = ExpectTrue<
  Equal<HeadingSize, z.infer<typeof HeadingSizeSchema>>
>
